module.exports = __webpack_public_path__ + "static/media/COLB-Screenshot-3.08d32b49.png";